import { Helmet } from 'react-helmet-async';
import PageHeader from './PageHeader';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container } from '@mui/material';
import Footer from 'src/components/Footer';
import NotificationList from './NotificationsList';

function NotificationsList() {
  return (
    <>
      <Helmet>
        <title>Announcement</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <NotificationList />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default NotificationsList;
